
import Vue from "vue";
import { Component, Inject, Prop } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";
import { DynamicFieldOutput } from "@/types/dynamic-data";
import DynamicDataFieldAttributes from "@/components/Reusable/ControlsTree/DynamicData/DynamicDataFieldAttributes.vue";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import { Control, ControlsTreeContext } from "@/types/controls";
import {
  getShortcodeFromDynamicField,
  getSlugFromDynamicFieldOutput
} from "@/lib/dynamic-data/utils";
import { configStore } from "@/store/store-accessor";
import NiceButton from "@/components/UI/NiceButton.vue";
import CopyButton from "@/components/Reusable/CopyButton.vue";

@Component({
  components: {
    CopyButton,
    NiceButton,
    Icon,
    DynamicDataFieldAttributes,
    Dropdown
  }
})
export default class DynamicInput extends Vue {
  @Inject({ from: "context", default: {} })
  readonly context!: ControlsTreeContext;

  @Prop()
  control!: Control;

  @Prop()
  value: any;

  @Prop()
  meta?: DynamicFieldOutput | null;

  @Prop({ default: 10 })
  iconSize!: number;

  get dynamicField() {
    if (!this.meta) return null;
    const slug = getSlugFromDynamicFieldOutput(this.meta);
    return configStore.dynamicFields.find(field => field.slug === slug);
  }

  get dynamicAttributes() {
    return this.meta?.attributes;
  }

  cancelDynamic() {
    this.$emit("clear", "");
  }

  setAttributeValue(value: DynamicFieldOutput) {
    if (!this.dynamicField) return;

    const shortcode = getShortcodeFromDynamicField(value, this.dynamicField);
    this.$emit("input", shortcode);
    this.$emit("change", {
      field: this.dynamicField.slug,
      shortcode,
      attributes: value
    });
  }

  get position() {
    return {
      left: true,
      bottom: true,
      offsetY: true
    };
  }

  get title() {
    return this.dynamicField?.label
      ? `${this.dynamicField.label} Options`
      : "Options";
  }
}
